export const findLiveInputFromBubble = (
  bubble: HTMLElement | null,
  path: string
): HTMLElement | null | undefined => {
  const parent = bubble?.parentNode?.parentNode as HTMLElement

  if (!parent) {
    return
  }

  return parent?.querySelector(`[data-name="${path}"]`) as HTMLElement
}
